import template from './setup_time_rules_help.html'
import * as Utils from '../../lib/savanna_utils.js'

class SetupTimeRulesHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
}

class SetupTimeRulesHelpPage
{
	constructor(bindings)
	{
		this.viewModel = new SetupTimeRulesHelpViewModel(this)
		this.bindings = bindings
	}

	async init()
	{
		Utils.refresh_data_visible_roles()
	}
}

// Register the dialog
export default {
	name: 'SetupTimeRulesHelp',
	dialog_class: SetupTimeRulesHelpPage,
	template: template,
	template_filename: 'translation/dialogs/setup_time_rules_help',
	provider: 'ps'
}
